export default "__VITE_ASSET__D_caMtN5__"